import {SetNavAppContent,SetNavAppMenu,SetNavAppModule,SetNavAppLink,SetNavAppName}from "./action_navigation";
import {SaveLoginInfo} from "./action-login";
import {SetPbxLiveInbound,SetPbxLiveOutbound,SetPbxLivePeer} from "./action-pbx-dashboard-live";
import {SetActiveIncomeCall,SetCurrentCalls} from "./action-asterisk";
import {LOGGED_IN,REMINDER_SET} from "../../constants";
export{
    SetNavAppContent,
    SetNavAppMenu,
    SetNavAppModule,
    SetNavAppName,
    SaveLoginInfo,
    SetNavAppLink,
    SetPbxLiveInbound,
    SetPbxLiveOutbound,
    SetPbxLivePeer,
    SetActiveIncomeCall,
    SetCurrentCalls
}

export const SaveReminder = (payload) => {
    return {
        type: REMINDER_SET,
        payload
    }
}

